import script from "./top.vue?vue&type=script&lang=ts&setup=true"
export * from "./top.vue?vue&type=script&lang=ts&setup=true"

import "./top.vue?vue&type=style&index=0&id=36b24802&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36b24802"]])

export default __exports__